export default {
    PAGO: 1,
    EM_ATRASO: 2,
    EM_ABERTO: 3
}